export default __webpack_public_path__ + "static/home2-4e518e11051101c384c61d121322e657.jpg";